import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ActivatedRoute } from "@angular/router";
import { QueryParamsService } from "common";
import { OfferListQueryParams } from "../../models/offer-query.model";
import { OfferFilterService } from "../../offer-filter.service";
import { OfferListData } from "./models/offer-list-data.model";
import { routerTransition } from "../../../shared/animations/router.animations";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: "ifb-offer-list",
    templateUrl: "./offer-list.component.html",
    styleUrls: ["./offer-list.component.scss"],
    animations: routerTransition,
    standalone: false
})
export class OfferListComponent implements OnInit {

  tableColumns: string[] = [
    "name",
    "productCode",
    "status",
    "amount",
    "paymentFrequency",
    "repaymentTerm",
    "drawTerm",
    "offerRate",
    "uniqueId",
  ];

  data: OfferListData;
  private applicationId: number;
  private offerBundleId: number;

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;
  queryParams: OfferListQueryParams;

  constructor(
    private route: ActivatedRoute,
    private offerFilterService: OfferFilterService,
    private queryParamsService: QueryParamsService
  ) { }

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: OfferListData) => {
        this.data = data;
      });
    this.route.queryParams
      .pipe(untilDestroyed(this))
      .subscribe(it => {
        this.queryParams = new OfferListQueryParams(this.queryParamsService.init(it));
      });
    this.initPathParams();
  }

  private initPathParams(): void {
    const pathFromRoot = this.route.snapshot.pathFromRoot;

    this.applicationId =
    this.queryParams.id !== undefined
        ?  this.queryParams.id
        : pathFromRoot[pathFromRoot.length - 2].params.id;
    this.offerBundleId =
    this.queryParams.offerBundleId !== undefined
        ?  this.queryParams.offerBundleId
        : pathFromRoot[pathFromRoot.length - 2].params.offerBundleId;

    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex = this.queryParams.skip / this.queryParams.limit;
  }

  sortData(): void {
    this.filter();
  }

  setPage(): void {
    this.filter();
  }

  private filter(): void {
    this.offerFilterService.filter(
      this.applicationId,
      this.offerBundleId,
      this.paginator,
      this.sort
    );
  }
}
